import clsx from "clsx";
import * as React from "react";

const CheckboxGroup = React.forwardRef<
	React.ElementRef<"div">,
	React.HTMLProps<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
	return (
		<div
			className={clsx(
				"flex flex-col w-full gap-2 p-3 border border-border rounded-md",
				className,
			)}
			{...props}
			ref={ref}
		>
			{children}
		</div>
	);
});
CheckboxGroup.displayName = "CheckboxGroup";

export { CheckboxGroup };
